import { render, staticRenderFns } from "./reportmcjs.vue?vue&type=template&id=2a623141&"
import script from "./reportmcjs.vue?vue&type=script&lang=js&"
export * from "./reportmcjs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports